import { useState, useEffect } from 'react'
import apiClient from '../../services/apiClient'
import Layout from '../../components/Layout'
import AdminTabs from '../../components/AdminTabs'
import CrudTable from '../../components/CrudTable'
import Spinner from '../../components/Spinner'

export default function AdminModels() {
  const [providers, setProviders] = useState([])
  const [models, setModels]       = useState([])
  const [loading, setLoading]     = useState(true)

  const load = () => {
    setLoading(true)
    Promise.all([
      apiClient.get('/admin/ai-model-providers?include_inactive=true'),
      apiClient.get('/admin/ai-models?include_inactive=true'),
    ])
      .then(([provRes, modRes]) => {
        setProviders(provRes.data)
        setModels(modRes.data.items)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => { load() }, [])

  const providerOptions = providers.filter((p) => p.is_active).map((p) => ({ value: p.id, label: p.name }))

  return (
    <Layout>
      <div className="page-header"><h1 className="page-title">Admin</h1></div>
      <AdminTabs />
      {loading ? (
        <div className="loading-state"><Spinner size="md" /> Loading…</div>
      ) : (
        <>
          {/* Providers */}
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <h2 className="card-section-title" style={{ marginBottom: '0.75rem' }}>
              AI Model Providers
            </h2>
            <CrudTable
              items={providers}
              columns={[
                { key: 'id',        label: 'ID' },
                { key: 'name',      label: 'Name', editable: true },
                { key: 'is_active', label: 'Active', editable: true, type: 'boolean' },
              ]}
              newItemFields={[{ key: 'name', label: 'Name' }]}
              onCreate={async (data) => {
                await apiClient.post('/admin/ai-model-providers', data)
                load()
              }}
              onUpdate={async (id, data) => {
                await apiClient.put(`/admin/ai-model-providers/${id}`, { name: data.name, is_active: Number(data.is_active) })
                load()
              }}
              onDelete={async (id) => {
                await apiClient.delete(`/admin/ai-model-providers/${id}`)
                load()
              }}
            />
          </div>

          {/* Models */}
          <div className="card">
            <h2 className="card-section-title" style={{ marginBottom: '0.75rem' }}>
              AI Models
            </h2>
            <CrudTable
              items={models}
              columns={[
                { key: 'id',            label: 'ID' },
                { key: 'provider_name', label: 'Provider' },
                { key: 'name',          label: 'Model Name', editable: true },
                { key: 'is_active',     label: 'Active', editable: true, type: 'boolean' },
              ]}
              newItemFields={[
                {
                  key: 'provider_id',
                  label: 'Provider',
                  type: 'select',
                  options: providerOptions,
                },
                { key: 'name', label: 'Model Name' },
              ]}
              onCreate={async (data) => {
                await apiClient.post('/admin/ai-models', {
                  provider_id: Number(data.provider_id),
                  name: data.name,
                })
                load()
              }}
              onUpdate={async (id, data) => {
                await apiClient.put(`/admin/ai-models/${id}`, { name: data.name, is_active: Number(data.is_active) })
                load()
              }}
              onDelete={async (id) => {
                await apiClient.delete(`/admin/ai-models/${id}`)
                load()
              }}
            />
          </div>
        </>
      )}
    </Layout>
  )
}
